// extracted by mini-css-extract-plugin
export default {"viewingContainer":"styles_viewingContainer__eAe3h","promptContainer":"styles_promptContainer__9wrz9","canvasContainer":"styles_canvasContainer__ZXlrX"};